import { PostAPI } from 'Components/Helper/Helpers';

export const AgentRegistration = async (request) => {
    return PostAPI(request, 'PaySprintPPI/AgentRegistration');
};

export const GenerateURL = async (request) => {
    return PostAPI(request, 'PaySprintPPI/GenerateURL');
};

export const CheckUserAgentID = async (request) => {
    return PostAPI(request, 'PaySprintPPI/CheckUserAgentID');
};